
export const getMonthDay = ({ ts }) => {
  const temp = new Date(Number(ts)).toISOString();
  return temp.substring(0, 10);
};
